import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
} from '@chakra-ui/react';
import { ElementType } from 'react';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

type InstagramConvWindowMenuProps = {
  orgId: string;
  instagramAccountId: string;
  onDeleteOpen: () => void;
};

export default function InstagramConvWindowMenu({
  orgId,
  instagramAccountId,
  onDeleteOpen,
}: InstagramConvWindowMenuProps) {
  const navigate = useNavigate();
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={<Icon as={HiOutlineDotsVertical as ElementType} />}
        variant="ghost"
        aria-label="Options"
      />

      <MenuList>
        <MenuItem color="red.500" onClick={onDeleteOpen}>
          Delete Conversation
        </MenuItem>
        <MenuItem
          color="red.500"
          onClick={() =>
            navigate(
              `/organization/${orgId}/inbox/instagram/${instagramAccountId}/settings`,
            )
          }
        >
          Settings
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
